import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LaasOption } from 'src/app/core/models/laas-option';
import { FacilityService } from 'src/app/core/services/facility.service';
import { deepCopy, getDataScopeByPermission, getForwarderByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { ForwarderService } from '../../services/forwarder.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { WarehousingRegistrationService } from '../../services/warehousing-registration.service';
import { AddWarehousingRegistrationRequest } from 'src/app/core/models/transport-operation/warehousing-registration';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DeliveryOrderService } from '../../services/delivery-order.service';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';

@Component({
  selector: 'laas-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.scss']
})
export class RegistrationFormComponent extends SessionBaseComponent  implements OnInit {

  readonly permissionCode = PermissionConstants.ViewRegistrationFormSearch;
  readonly helpPermissionCode = PermissionConstants.ViewRegistrationForm;
  @ViewChild('edcDate') edcDate!: CalendarComponent;
  currentLang: string = this.laasSetting.language;
  createForm:FormGroup;
  isLoading:boolean = false;
  forwarderOptions: Array<LaasOption> = [];
  orgOptions:Array<LaasOption> = [];
  referenceTypeOptions:Array<LaasOption> = [];
  submitted: boolean = false;
  vendorSuggests: string[] = [];
  vendorOptions: any[] = [];
  addWarehousingRegistrationRequest:AddWarehousingRegistrationRequest;
  isShowImport:boolean = false;
  abnormalOptions: any[] = [];

  constructor(private fb: FormBuilder,injector: Injector,
    private facilityService: FacilityService,
    private forwarderService: ForwarderService,
    private dropdownOptionsService: DropdownOptionsService,
    private commonDataService: CommonDataService,
    private dOService: DeliveryOrderService,
    private warehousingRegistrationService:WarehousingRegistrationService) {
    super(injector);

    this.createForm = this.fb.group({
      referenceKey:[{ value: '',disabled: true}, Validators.required,],
      referenceType:[null, Validators.required],
      forwarderCode:[null, Validators.required],
      vendorCode:null,
      vendorName:[null, Validators.required],
      orgId:[null, Validators.required],
      totalCtn:[null, Validators.required],
      palletCnt:[null],
      createUser: ['', Validators.required],
      createDt: ['', Validators.required],
      edc: ['', Validators.required],
      facility:['', Validators.required],
      abnormalReference:[null]
    })

    this.addWarehousingRegistrationRequest={
      registrationList:[]
    };
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    var defaultDt=new Date();
    this.createForm.controls.createUser.setValue(this.userProfile.loginAccount);
    this.createForm.controls.createDt.setValue(defaultDt);
    this.createForm.controls.facility.setValue(this.laasSetting.facility);

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.forwarderOptions = options.filter((x: any) => {
          return ( this.userProfile.userType === UserType.SuperAdmin.toString() ||
          this.userProfile.userType === UserType.Shipping.toString() ||
          getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.facilityService.getLetterOrgOptions(this.laasSetting.facility, "")
      .subscribe({
        next: (options: any[]) => {
          this.orgOptions = [...options].map((x: any) => {
            return {
              label: `${x.legalEntityOUCode}-${x.legalEntityOUName} (${x.legalEntityReferenceCode})`,
              value: x.legalEntityOUCode,
              source: x
            };
          });
        }
      });

    this.warehousingRegistrationService.getAbnormalOptions("WarehousingAbnormalTaskCode")
    .subscribe({
      next:(option:any)=>{
        const abnormalList = option.appCsmSettingDetailList;
        if(this.laasSetting.language == 'zh-tw'){
          this.abnormalOptions = [...abnormalList].map((x:any) =>{
            return {
              label:  `${x.setupValue}-${x.setupValueDesc}`,
              value: x.setupValue,
              source: x
            };
          })
        }else{
          this.abnormalOptions = [...abnormalList].map((x:any) =>{
            return {
              label:  `${x.setupValue}-${x.setupValue2}`,
              value: x.setupValue,
              source: x
            };
          })
        }
      }
    })

      this.referenceTypeOptions=[
        { label: this.translateService.instant("RegistrationForm.Create.Hawb"), value: 'HawbNo' },
        { label: this.translateService.instant("RegistrationForm.Create.WhNo"), value: 'WarehousingNo' },
        { label: this.translateService.instant("RegistrationForm.Create.BondedNo"), value: 'BondedNo' }   ];

  }

  getVendorOptions(event: any): void {
    const key: string = event.query;
    if (key != null && key.length > 1) {
      this.dropdownOptionsService.getVendorOptions(key).subscribe({
        next: (options: any[]) => {
          this.vendorSuggests = options.map(x => x.optionDesc);
          this.vendorOptions = options.map(x => {
            return {label: x.optionDesc, value: x.optionCode };
          });
        }
      });
    }
  }

  saveBtnClick(event:any){
    this.isLoading=true;
    this.createForm.value.referenceKey = this.createForm.value.referenceKey.trim();

    if (this.createForm.invalid) {
      this.submitted = true;
      this.toastService.warn(this.translateService.instant('ReceiptFormQuery.Alert.CheckRequired'));
      this.loader.hide();
      return;
    }

    this.addWarehousingRegistrationRequest.registrationList.push(this.createForm.value);
    console.log(this.addWarehousingRegistrationRequest.registrationList);
    this.warehousingRegistrationService.addWarehousingRegistration(this.addWarehousingRegistrationRequest)
      .subscribe({
        next: result => {
          console.log(result);
          const dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
          this.routeStateService.navigateTo('/TransportOperation/RegistrationFormSearch', { registrationKeyList: result.registrationKeyList,dataScopes:dataScopes, errMsgs: [] });
          this.isLoading = false;
        },
        error: (err: any) => {
          this.toastErrorMessage(err.error);
          this.addWarehousingRegistrationRequest.registrationList.length = 0;
          this.isLoading=false;
        }
      });
    this.isLoading=false;
  }

  selectReferenceType(){
    if(this.createForm.controls.referenceType.value != null){
      this.createForm.controls.referenceKey.enable();
    }
  }

  visibleChangeOfImport(val:boolean){
    this.isShowImport = val;
  }

  templateDownloadBtn(): void {

    var fileType = 'WarehousingRegistration';
    var fileName = 'Warehousing Registration Template';
    this.warehousingRegistrationService.downloadTemplate().subscribe({
      next: result => {
        var blob = new Blob([result], { type: 'application/octet-stream' }); // application後面接下載的副檔名

        let downloadURL = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = downloadURL;
        link.download = fileName + '.xlsx';
        link.click();
      }
    });
  }
  dateOnChange(date: any,type:string) {
    switch (type) {
      case "edcDate":
        this.createForm.get('edc')!.setValue(date.date);
        break;
    }
  }
}
